(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cozy-nido-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cuevita-product-controller')) {
  class CuevitaProductController extends HTMLElement {
    connectedCallback() {
      const root=this.closest('[data-cuevita]');if(!root||root.dataset.ready)return;root.dataset.ready='true';
      const variants=JSON.parse(root.querySelector('[data-cuevita-variants]').textContent);
      const labels=JSON.parse(root.querySelector('[data-cuevita-labels]').textContent);
      const radios=[...root.querySelectorAll('.cne__packs input')];
      const units=[...root.querySelectorAll('.cne__unit')];
      const selects=[...root.querySelectorAll('[data-variant]')];
      const submit=root.querySelector('.cne__submit');
      const error=root.querySelector('.cne__error');
      let busy=false;
      const quantity=()=>Number(radios.find(r=>r.checked).value);
      const chosen=()=>selects.slice(0,quantity()).map(s=>variants.find(v=>v.id===s.value));
      const valid=()=>{const counts={};for(const variant of chosen()){if(!variant||!variant.available)return false;counts[variant.id]=(counts[variant.id]||0)+1;if(variant.tracked&&counts[variant.id]>variant.quantity)return false;}return true;};
      const sync=()=>{
        units.forEach((unit,index)=>{unit.hidden=index>=quantity();selects[index].disabled=index>=quantity();});
        selects.forEach((select,index)=>{const variant=variants.find(v=>v.id===select.value);units[index].querySelector('[data-stock]').textContent=!variant?.available?labels.sold:variant.tracked&&variant.quantity<=5?labels.low.replace('__COUNT__',variant.quantity):labels.available;});
        submit.disabled=busy||!valid();
        submit.textContent=busy?labels.busy:!valid()?labels.sold:quantity()===3?labels.trio:quantity()===2?labels.duo:labels.one;
        root.querySelector('[data-sticky-price]').textContent=quantity()===3?labels.trioPrice:quantity()===2?labels.duoPrice:root.querySelector('.cne__pack-row b').textContent;
      };
      radios.forEach(radio=>radio.addEventListener('change',()=>{error.hidden=true;sync();}));
      const hero=root.querySelector('.cne__hero-image');
      const thumbs=[...root.querySelectorAll('[data-photo]')];
      thumbs.forEach(thumb=>thumb.addEventListener('click',()=>{hero.removeAttribute('srcset');hero.src=thumb.dataset.photo;hero.alt=thumb.dataset.photoAlt;thumbs.forEach(item=>item.setAttribute('aria-pressed',String(item===thumb)));}));
      selects.forEach((select,index)=>select.addEventListener('change',()=>{error.hidden=true;sync();if(index===0){const variant=variants.find(v=>v.id===select.value);if(variant?.image){hero.removeAttribute('srcset');hero.src=variant.image;hero.alt=variant.alt;}const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState(null,'',url);}}));
      submit.addEventListener('click',async()=>{
        if(busy)return;if(!valid()){error.textContent=labels.quantity;error.hidden=false;return;}busy=true;error.hidden=true;sync();
        try{
          const aggregated={};chosen().forEach(variant=>{aggregated[variant.id]=(aggregated[variant.id]||0)+1;});
          const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:Object.entries(aggregated).map(([id,qty])=>({id,quantity:qty}))})});
          const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:labels.error);
          location.assign(root.dataset.cartUrl);
        }catch(err){error.textContent=err.message||labels.error;error.hidden=false;busy=false;sync();}
      });
      const sticky=root.querySelector('.cne__sticky');
      const buy=root.querySelector('.cne__buy');
      this.observer=new IntersectionObserver(([entry])=>sticky.classList.toggle('is-visible',!entry.isIntersecting&&entry.boundingClientRect.bottom<0));
      this.observer.observe(buy);
      sync();
    }
    disconnectedCallback(){this.observer?.disconnect();}
  }
  customElements.define('cuevita-product-controller',CuevitaProductController);
}
document.querySelectorAll('[data-cuevita]').forEach(root=>{if(!root.querySelector('cuevita-product-controller'))root.appendChild(document.createElement('cuevita-product-controller'));});
document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('[data-cuevita]').forEach(root=>{if(!root.querySelector('cuevita-product-controller'))root.appendChild(document.createElement('cuevita-product-controller'));});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cozy-nido"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cozy-nido-controller')) {
  class CozyNidoController extends HTMLElement {
    connectedCallback() {
      const root=this.closest('[data-cozy-nido]'); if(!root||root.dataset.ready)return;root.dataset.ready='true';
      const variants=JSON.parse(root.querySelector('[data-nido-variants]').textContent), labels=JSON.parse(root.querySelector('[data-nido-labels]').textContent);
      const radios=[...root.querySelectorAll('.cn-packs input')], units=[...root.querySelectorAll('.cn-unit')], selects=[...root.querySelectorAll('[data-variant]')], submit=root.querySelector('.cn-submit'), err=root.querySelector('.cn-error');
      let busy=false;
      const quantity=()=>Number(radios.find(r=>r.checked).value);
      const chosen=()=>selects.slice(0,quantity()).map(s=>variants.find(v=>v.id===s.value));
      const valid=()=>{const counts={};for(const v of chosen()){if(!v||!v.available)return false;counts[v.id]=(counts[v.id]||0)+1;if(v.tracked&&counts[v.id]>v.quantity)return false;}return true;};
      const sync=()=>{units.forEach((unit,i)=>{unit.hidden=i>=quantity();selects[i].disabled=i>=quantity();});
        selects.forEach((s,i)=>{const v=variants.find(v=>v.id===s.value);units[i].querySelector('[data-stock]').textContent=!v?.available?labels.sold:v.tracked&&v.quantity<=5?labels.low.replace('__COUNT__',v.quantity):labels.available;});
        submit.disabled=busy||!valid();submit.textContent=busy?labels.busy:!valid()?labels.sold:quantity()===3?labels.trio:quantity()===2?labels.duo:labels.one;
        root.querySelector('[data-sticky-price]').textContent=quantity()===3?'$29.990':quantity()===2?'$22.990':'$12.990';};
      radios.forEach(r=>r.addEventListener('change',()=>{err.hidden=true;sync();}));
      const hero=root.querySelector('.cn-hero-image'), thumbs=[...root.querySelectorAll('[data-photo]')];
      const show=(url,alt)=>{hero.removeAttribute('srcset');hero.src=url;hero.alt=alt;};
      thumbs.forEach(t=>t.addEventListener('click',()=>{show(t.dataset.photo,t.dataset.photoAlt);thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));}));
      selects.forEach((s,index)=>s.addEventListener('change',()=>{err.hidden=true;sync();if(index===0){const v=variants.find(v=>v.id===s.value);const idx=variants.indexOf(v);if(thumbs[idx])thumbs[idx].click();const u=new URL(location.href);u.searchParams.set('variant',s.value);history.replaceState(null,'',u);}}));
      root.querySelectorAll('[data-select-duo]').forEach(a=>a.addEventListener('click',()=>{radios[1].checked=true;sync();}));
      submit.addEventListener('click',async()=>{if(busy)return;if(!valid()){err.textContent=labels.quantity;err.hidden=false;return;}busy=true;err.hidden=true;sync();
        try {const aggregated={};chosen().forEach(v=>{aggregated[v.id]=(aggregated[v.id]||0)+1;});
          const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:Object.entries(aggregated).map(([id,quantity])=>({id:Number(id),quantity}))})});
          const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:labels.error);
          location.assign(root.dataset.cartUrl);
        } catch(e){err.textContent=e.message||labels.error;err.hidden=false;busy=false;sync();}
      });
      const sticky=root.querySelector('.cn-sticky'), buy=root.querySelector('.cn-buy');this.observer=new IntersectionObserver(([entry])=>{sticky.classList.toggle('is-visible',!entry.isIntersecting&&entry.boundingClientRect.bottom<0);});this.observer.observe(buy);sync();
    }
    disconnectedCallback(){this.observer?.disconnect();}
  }
  customElements.define('cozy-nido-controller',CozyNidoController);
}
document.querySelectorAll('[data-cozy-nido]').forEach(root=>{if(!root.querySelector('cozy-nido-controller'))root.appendChild(document.createElement('cozy-nido-controller'));});
document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('[data-cozy-nido]').forEach(root=>{if(!root.querySelector('cozy-nido-controller'))root.appendChild(document.createElement('cozy-nido-controller'));});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
